<template>
  <el-card class="box-card" v-loading="!locationParams.type">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span style="font-size: 24px">{{
        JSON.parse(this.$UrlEncode.decode(this.$route.query.key)).name
      }}</span>
      <div class="head-text" style="float: right">
        <el-input
          placeholder="请输入"
          class="search-input"
          style="width: 300px"
          v-model="searchword"
        ></el-input>
        <el-button
          slot="append"
          icon="el-icon-search"
          class="mar-t80"
          @click="GetFormAuditFlowList"
        ></el-button>
        <el-button @click="addformShow(null)" type="primary" plain
          >新增</el-button
        >
        <!-- <el-button type="danger" plain>批量删除</el-button> -->
      </div>
    </div>

    <el-table
      height="72vh"
      align="center"
      class="table"
      :data="formAuditFlowList"
    >
      <el-table-column
        align="center"
        type="index"
        label="序号"
        width="80"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="fafl03"
        label="名称"
      ></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            @click="addformShow(scope.row.fafl01)"
            size="small"
            type="primary"
            plain
            >编辑</el-button
          >
          <el-button
            @click="CopyFormAuditFlow(scope.row.fafl01)"
            size="small"
            type="primary"
            plain
            >复制</el-button
          >
          <el-popconfirm
            style="margin-left: 10px"
            @confirm="DelFormAuditFlow(scope.row.fafl01)"
            title="确定删除吗？"
          >
            <el-button slot="reference" size="small" type="danger" plain
              >删除</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      align="center"
      class="mar-top20"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[100, 50, 10]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>

    <!-- 添加 -->

    <el-dialog title="流程设置" :visible.sync="addformisShow" width="70%">
      <p style="color: #2a81ee; margin: 10px 0">流程名称</p>
      <el-input v-model="auditflow.fafl03"></el-input>
      <p style="color: #2a81ee; margin: 10px 0">流程步骤</p>
      <el-descriptions
        v-for="(item, index) in detailList"
        :key="index"
        class="margin-top"
        :column="5"
        border
        size="medium"
      >
        <el-descriptions-item>
          <template slot="label">
            节点名称
          </template>
          <el-input v-model="item.fadt03" size="mini"></el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 协同人员 </template>
          <el-cascader
            :options="deptData"
            :props="props"
            clearable
            filterable
            v-model="item.fadt04"
            :show-all-levels="false"
            :placeholder="item.name || '请选择人员'"
            :title="item.name || '请选择人员'"
          ></el-cascader>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 协同性质 </template>
          <el-select v-model="item.fadt05" size="mini" placeholder="请选择">
            <el-option
              v-for="item in auditOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 驳回到 </template>
          <el-select v-model="item.fadt09" size="mini">
            <el-option
              v-for="(item2, index2) in item.bohList"
              :key="index2"
              :label="item2.fadt03"
              :value="item2.fadt06"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 操作 </template>
          <div style="width: 115px">
            <i
              @click="add(index)"
              style="font-size: 24px; color: green; cursor: pointer"
              class="el-icon-plus"
            ></i>
            <i
              @click="del(index)"
              v-if="detailList.length > 1"
              style="
                font-size: 24px;
                color: red;
                cursor: pointer;
                margin-left: 5px;
              "
              class="el-icon-minus"
            ></i>
            <i
              @click="gotop(index)"
              v-if="index > 0"
              style="
                font-size: 24px;
                color: #000;
                cursor: pointer;
                margin-left: 5px;
              "
              class="el-icon-upload2"
            ></i>
            <i
              @click="gobottom(index)"
              v-if="index < detailList.length - 1"
              style="
                font-size: 24px;
                color: blue;
                cursor: pointer;
                margin-left: 5px;
              "
              class="el-icon-download"
            ></i>
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <p style="color: #2a81ee; margin: 10px">抄送流程</p>

      <el-cascader
        :options="deptData"
        :props="props"
        clearable
        filterable
        v-model="csUserList"
        :show-all-levels="false"
        :placeholder="csUserName"
        :title="csUserName"
      ></el-cascader>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="AddOrUpdateFormAuditFlow"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  AddOrUpdateFormAuditFlow,
  GetFormAuditFlowList,
  GetOneFormAuditFlow,
  DelFormAuditFlow,
  CopyFormAuditFlow,
  GetProjectdeptZTree,
  GetMember,
} from "@/setAxios";
import _ from "lodash";
export default {
  data() {
    return {
      searchword: "",
      pageIndex: 1,
      pageSize: 15,
      formAuditFlowList: [],
      total: 0,
      addformisShow: false,
      auditflow: {
        fafl01: 0,
        fafl02: localStorage.xid,
        fafl03: "",
        fafl04: 0,
        fafl05: "",
      },
      detailList: [
        {
          fadt01: 0,
          fadt02: 0,
          fadt03: "",
          fadt04: "",
          fadt05: "",
          fadt06: "",
          fadt07: 1,
          fadt08: new Date(),
          fadt09: "",
          bohList: [],
        },
      ],
      auditOptions: [
        {
          value: 1,
          label: "会签",
        },
        {
          value: 2,
          label: "或签",
        },
      ],
      userList: [],
      csUserList: [],
      csList: null,
      csUserName: null,
      //处理部门人员开始------------------------------------
      treeObj: [],
      deptData: [],
      personData: [],
      props: { multiple: true },
      //处理部门人员结束------------------------------------
      locationParams: {},
    };
  },
  computed: {},
  created() {},
  watch: {
    $route: {
      handler: function(val, old) {
        var search = window.location.hash
          .substr(1)
          .split("=")[1]
          .replace(/%3D/g, "=");
        search = this.$UrlEncode.decode(search);
        this.locationParams = JSON.parse(search);
        if (!this.locationParams.type) {
          this.$message.error("参数丢失，页面禁止使用");
          return;
        }
        this.GetFormAuditFlowList();
        this.GetDeptAndPersonTree();
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  methods: {
    //处理部门人员开始------------------------------------
    async GetDeptAndPersonTree() {
      this.deptData = [];
      let params = {
        id: localStorage.getItem("xid"),
      };
      let dept = await GetProjectdeptZTree({ params });
      dept.Data.forEach((v) => {
        this.deptData.push({
          value: v.prde01,
          label: v.prde03,
          parentId: v.prde07,
          disabled: false,
          isUser: false,
        });
      });
      this.deptData = this.getTreeDate(this.deptData, "value", "parentId");
      params = {
        seachword: "",
        id: localStorage.getItem("xid"),
        cid: localStorage.getItem("pid"),
        bid: "null",
        pageIndex: 1,
        pageSize: 10000,
      };
      let person = await GetMember({ params });
      this.personData = person.Data.list;
      this.CombineDeptPerson(this.deptData, this.personData);
    },
    //将部门和人员合并
    CombineDeptPerson(data, person) {
      data.forEach((v) => {
        if (!v.isUser) {
          let pers = person.filter((x) => x.prde01 == v.value);
          if (pers.length == 0 && !v.children) {
            v.disabled = true;
          } else if (pers.length) {
            if (!v.children) v.children = [];
            pers.forEach((p) => {
              v.children.push({
                value: p.user01,
                label: p.user04,
                isUser: true,
              });
            });
          }
          if (v.children) {
            this.CombineDeptPerson(v.children, person);
          }
        }
      });
    },
    getTreeDate(data, idName, pidName) {
      let result = [];
      if (!Array.isArray(data)) {
        return result;
      }
      data.forEach((item) => {
        delete item.children;
      });
      let map = {};
      data.forEach((item) => {
        map[item[idName]] = item;
      });

      data.forEach((item) => {
        let parent = map[item[pidName]];
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          result.push(item);
        }
      });
      return result;
    },
    //处理部门人员结束------------------------------------
    addformShow(id) {
      if (id) {
        this.GetOneFormAuditFlow(id);
      }
      this.addformisShow = true;
    },
    async GetOneFormAuditFlow(id) {
      let params = {
        id,
      };
      let res = await GetOneFormAuditFlow({ params });
      this.auditflow = res.Data.auditflow;
      this.detailList = res.Data.detailList.filter((ele) => ele.fadt07 == 1);
      this.detailList.forEach((item, i) => {
        item.bohList = this.detailList.slice(0, i);
      });
      this.csList = res.Data.detailList.find((ele) => ele.fadt07 == 2);
      if (this.csList) {
        this.csUserList = this.csList.fadt04;
        this.csUserName = this.csList.name;
      }
    },
    async DelFormAuditFlow(ids) {
      let res = await DelFormAuditFlow({ ids });
      if (res.Code) {
        this.$message.success("删除成功");
        this.GetFormAuditFlowList();
      }
    },
    async CopyFormAuditFlow(id) {
      let res = await CopyFormAuditFlow({ id });
      if (res.Code) {
        this.$message.success("复制成功");
        this.GetFormAuditFlowList();
      }
    },
    async AddOrUpdateFormAuditFlow() {
      let detailList2 = _.cloneDeep(this.detailList);
      this.auditflow.fafl05 = this.locationParams.type;
      if (
        !detailList2.length ||
        !detailList2.every(
          (w) => w.fadt03 != "" && w.fadt04.length && w.fadt05 != ""
        ) ||
        this.auditflow.fafl03.trim() == ""
      ) {
        this.$message.error("请完善协同流程");
        return;
      }
      detailList2.forEach((ele, index) => {
        if (typeof ele.fadt04 == "object") {
          var newarr = [];
          ele.fadt04.forEach((v) => {
            newarr.push(v[v.length - 1]);
          });
          ele.fadt04 = newarr.join(",");
        }
      });
      if (this.csUserList.length) {
        var newarr = [];
        if (typeof this.csUserList == "object") {
          this.csUserList.forEach((v) => {
            newarr.push(v[v.length - 1]);
          });
        }
        detailList2.push({
          fadt01: this.csList ? this.csList.fadt01 : 0,
          fadt02: 0,
          fadt03: "",
          fadt04: newarr.length ? newarr.join(",") : this.csUserList,
          fadt05: "",
          fadt06: "",
          fadt07: 2,
          fadt08: new Date(),
        });
      }
      let params = {
        auditflow: this.auditflow,
        detailList: detailList2,
      };
      let res = await AddOrUpdateFormAuditFlow(params);
      if (res.Code > 0) {
        this.$message.success("添加成功");
        this.addformisShow = false;
        this.auditflow = {
          fafl01: 0,
          fafl02: localStorage.xid,
          fafl03: "",
          fafl04: 0,
        };
        this.detailList = [
          {
            fadt01: 0,
            fadt02: 0,
            fadt03: "",
            fadt04: [],
            fadt05: "",
            fadt06: "",
            fadt07: 1,
            fadt08: new Date(),
            fadt09: "",
            bohList: [],
          },
        ];
        this.GetFormAuditFlowList();
      }
    },
    async GetFormAuditFlowList() {
      let params = {
        xid: localStorage.xid,
        tempId: this.locationParams.type,
        searchword: this.searchword,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      let res = await GetFormAuditFlowList({ params });
      this.formAuditFlowList = res.Data.list;
      this.total = res.Data.total;
    },
    add(index) {
      if (this.detailList.some((w) => w.fadt03 == "")) {
        this.$message.error("请填写节点名称");
        return;
      }
      this.detailList.splice(index + 1, 0, {
        fadt01: 0,
        fadt02: 0,
        fadt03: "",
        fadt04: [],
        fadt05: "",
        fadt06: "",
        fadt07: 1,
        fadt08: new Date(),
        fadt09: "",
      });
      this.detailList.forEach((item, i) => {
        item.fadt09 = "";
        item.fadt06 = i + 1;
        item.bohList = this.detailList.slice(0, i);
      });
    },
    del(index) {
      this.detailList.splice(index, 1);
      this.detailList.forEach((item, i) => {
        item.fadt09 = "";
        item.fadt06 = i + 1;
        item.bohList = this.detailList.slice(0, i);
      });
    },
    gotop(index) {
      let obj = _.cloneDeep(this.detailList[index]);
      this.detailList[index] = _.cloneDeep(this.detailList[index - 1]);
      this.detailList[index - 1] = obj;
      this.detailList.forEach((item, i) => {
        item.fadt09 = "";
        item.fadt06 = i + 1;
        item.bohList = this.detailList.slice(0, i);
      });
      this.detailList = JSON.parse(JSON.stringify(this.detailList));
    },
    gobottom(index) {
      let obj = _.cloneDeep(this.detailList[index]);
      this.detailList[index] = _.cloneDeep(this.detailList[index + 1]);
      this.detailList[index + 1] = obj;
      this.detailList.forEach((item, i) => {
        item.fadt09 = "";
        item.fadt06 = i + 1;
        item.bohList = this.detailList.slice(0, i);
      });
      this.detailList = JSON.parse(JSON.stringify(this.detailList));
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetFormAuditFlowList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetFormAuditFlowList();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-descriptions-item__cell {
  width: 200px;
  font-size: 12px;
}
/deep/.el-descriptions__body
  .el-descriptions__table
  .el-descriptions-item__cell {
  text-align: center;
}
</style>
